// extracted by mini-css-extract-plugin
export default {"dataArea":"Roles_dataArea__Y0XNj","myScroll":"Roles_myScroll__fNrNZ","modalDataArea":"Roles_modalDataArea__kGi6u"};